module.exports = "../../static/img/fill.6ef1315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fill.png
// module id = SUD+
// module chunks = 36